export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewsListing.vue?vue&type=template&id=2241732c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListing.vue?vue&type=template&id=2241732c&scoped=true&
// module id = 74
// module chunks = 0